import Meta from 'src/components/meta/Meta';

const HomeMeta = () => <Meta
  title={`BrickX: Property investment accessible for all Australians.`}
  description="BrickX is the smart affordable way to build your home deposit or grow your wealth. Start investing in property for only a few hundred dollars."
  keywords="Property Investment"
/>;

export default HomeMeta;
